import { cn } from '@magicdoorinc/ui';
import { useNavigate } from '@solidjs/router';
import { Show } from 'solid-js';
import BackIcon from '~/assets/images/head-layout/back.svg?component-solid';
import PropertyTextImage from '~/assets/images/head-layout/property-text.svg';
import PropertyImage from '~/assets/images/head-layout/property.svg';
import type { Component, JSX } from 'solid-js';

type HeadLayoutProps = {
  type: 'unit' | 'property' | 'lease';
  backLink?: string | (() => void);
  children: JSX.Element;
  class?: string;
};

export const HeadLayout: Component<HeadLayoutProps> = (props) => {
  const navigate = useNavigate();
  function onClickBack() {
    if (typeof props.backLink === 'function') {
      props.backLink();
      return;
    }
    props.backLink && navigate(props.backLink);
  }

  return (
    <div class={cn('relative flex items-center rounded-t-lg pr-4', props.class)}>
      <div
        class="before:contents-[''] group relative hidden cursor-pointer items-center justify-center px-3 py-[18px] before:absolute before:right-0 before:top-1/2 before:h-[44px] before:w-px before:-translate-y-1/2 before:bg-dark-separator md:flex"
        onClick={() => onClickBack()}>
        <BackIcon class="size-8 text-dark-text-03 transition-all ease-in-out group-hover:text-dark-text-01 group-active:text-dark-text-01 xl:w-auto" />
      </div>
      <div class="flex-1 py-3 pl-3 xl:pl-4">{props.children}</div>
      <div class="relative mr-1 hidden items-center gap-x-2 xl:mr-2 xl:flex xl:gap-x-4">
        <Show when={props.type === 'property'}>
          <img src={PropertyTextImage} class="h-4 w-auto xl:h-auto" />
          <img src={PropertyImage} class="-mb-6 w-8 xl:-mb-8 xl:w-auto" />
        </Show>
      </div>
    </div>
  );
};
